/*jshint esversion: 6 */
import Ajax from '../common/Ajax';
import * as Utils from '../common/Utils';
import foreachPolyfill from "../common/polyfill-foreach";

let WidgetVideoTranscript = function (config) {

    let getTranscriptBtn = function () {
        return document.querySelector('.' + config.buttonClass);
    };

    let getTranscript = function () {
        return document.querySelector('.' + config.wrapperClass);
    };

    let clickTranscriptBtn = function () {
        console.log('the transcript button was clicked');
    }

    let toggleDisplayTranscript = function (elem) {
        elem.classList.toggle('active');
    }

    let toggleBtn = function (elem) {
        elem.classList.toggle('sg-btn');
        elem.classList.toggle('sg-btn-cta');
        elem.classList.toggle('btn-blue');
    }

    let scrollToElement = function (element, to, duration) {

        if (duration <= 0) return;

        let bodyScrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);

        let difference = to - bodyScrollTop;
        let perTick = difference / duration * 10;

        setTimeout(function() {

            // set the scroll position
            element.scrollTop = element.scrollTop + perTick;
            document.body.scrollTop = document.body.scrollTop + perTick;

            // check position
            let position = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
            if (position === to) return;

            scrollToElement(element, to, duration - 10);
        }, 10);
    }


    return {
        getTranscript: getTranscript,
        getTranscriptBtn: getTranscriptBtn,
        clickTranscriptBtn: clickTranscriptBtn,
        toggleDisplayTranscript: toggleDisplayTranscript,
        toggleBtn: toggleBtn,
        scrollToElement: scrollToElement
    };

};

export default WidgetVideoTranscript;